import {
  Input,
  Component,
  OnInit,
  forwardRef,
  ElementRef,
  ViewChild,
  EventEmitter,
  Output,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  AbstractControl,
} from '@angular/forms';
import { NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { Subscription, Subject, Observable, Observer } from 'rxjs';
import { HttpClient } from '@angular/common/http';

declare var $: any;

export const TEXT_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => InputNaturalNumberComponent),
  multi: true,
};

@Component({
  selector: '[naturalNumberInput]',
  templateUrl: 'input-natural-number.component.html',
  providers: [TEXT_VALUE_ACCESSOR, NgbTooltipConfig],
})
export class InputNaturalNumberComponent
  implements ControlValueAccessor, OnInit {
  @Input() labelInput: string;
  @Input() control: AbstractControl;
  @Input() location: string;
  @Input() minValue: number = -10000000
  @Input() mandatory: boolean;
  @Input() checkFormat: boolean;
  @Input() maxLength: number;
  @Input() type: string = 'text';
  @Input() allowNegative: boolean = false;
  @ViewChild('dinput') dinput!: ElementRef<HTMLInputElement>;
  @Input() highlight: boolean = false;
  @Input() highlightLabel: string = null;
  @Output() onModelChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() onKeyUp: EventEmitter<string> = new EventEmitter<string>();

   _value: string;
   _current: boolean;
  onTouchedCallback: () => void = () => {};
  onChangeCallback: (_: any) => void = () => {};
  input: any;
  randomId: string = this.getRandomId();
  showAlert: boolean = false;
  @Input() submitPending: boolean;
  public enableObservable: Observable<boolean>;
  private subscription: Subscription = null;
  private enableObserver: Observer<boolean>;
  constructor(private httpService: HttpClient) {}

  ngOnInit(): void {
    if (!this.submitPending) {
      this.createServiceSubscription();
    }
    if (!this.mandatory) {
      this.mandatory = false;
    }

    if (!this.checkFormat) {
      this.checkFormat = false;
    }
  }

  onChange(value: string) {
    value = value.split('\\').join('/');
    this._value = value;
    this.dinput.nativeElement.value = value;
    this.onChangeCallback(value ? value : undefined);
    this.onModelChange.emit(value);
  }

  private createServiceSubscription() {
    this.enableObservable = new Observable<boolean>((observer) => {
      this.enableObserver = observer;
      if (this.enableObserver) {
        this.submitPending = true;
      } else {
        this.submitPending = false;
      }
    });
  }

  onBlur(): any {
    let regex = this.allowNegative ? /^[-+]?[0-9]+$/g : /^[0-9]+$/g;
    if (!regex.test(this._value)) {
      this._value = '';
      this.dinput.nativeElement.value = '';
      this.showAlert = true;
    }
    this.onChangeCallback(
      this.dinput.nativeElement.value && this.dinput.nativeElement.value.toString().trim().length !== 0
        ? this.dinput.nativeElement.value
        : undefined
    );
  }

  validate(event: any) {
    let theEvent = event || window.event;
    let key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
    let regex = this.allowNegative ? /^[-+]?[0-9]*$/g : /^[0-9]+$/g;
    let value = this._value;
    if (!value) {
      value = '';
    }
    let test = this.allowNegative
      ? regex.test(key + value) || regex.test(value + key)
      : regex.test(value + key);
    // if (!regex.test(value + key)) {
      if (!test) {
        this.showAlert = true; // Imposta showAlert a true se il formato non è valido
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
        this.onKeyUp.emit(this._value);
    } else {
      this.onKeyUp.emit(this._value);
      this.showAlert = false; // Nasconde l'alert se il formato è valido
    }
  }

  writeValue(value: string): void {
    this._value = value;
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  getRandomId(length: number = 10): string {
    return crypto.randomUUID();
  }

  getHighlight() {
    return this.highlight ? ' highlight-border-input' : '';
  }
}
